/**
 * Policy domain types.
 * Legacy endpoints:
 *   GET  /api/policy?orderBy=...&sortBy=...&q=...&policy_group=...&page=N
 *   POST /api/policy                       — create
 *   POST /api/policies/:policy_key         — update (note: plural `/policies/`)
 */

export const POLICY_GROUPS = {
  APPLICATION: 'APPLICATION',
  COMPANY: 'COMPANY',
  CRM: 'CRM',
  CONFIGURATION: 'CONFIGURATION',
  DEFAULT: 'DEFAULT',
  HOUSINGASSIST: 'HOUSING ASSIST',
  INVITE: 'INVITE',
  PROPERTY: 'PROPERTY',
  REFERRINGAGENCY: 'REFERRING AGENCY',
  REPORTS: 'REPORTS',
  RESIDENT: 'RESIDENT',
  STOCK_REGISTRY: 'STOCK REGISTRY',
  TRANSFER: 'TRANSFER',
  USERMANAGEMENT: 'USERMANAGEMENT',
} as const

export type PolicyGroupKey = keyof typeof POLICY_GROUPS

export interface Policy {
  policy_key?: string
  policy_name: string
  policy_group: PolicyGroupKey | string
  policy_description: string
}

export interface PolicyListResponse {
  data: Policy[]
  current: number
  last: number
  total?: number
  per_page?: number
}

export type PolicySortKey = 'policy_name' | 'policy_group' | 'policy_description'
export type SortDirection = 'asc' | 'desc'

export interface PolicyListParams {
  orderBy?: PolicySortKey
  sortBy?: SortDirection
  q?: string
  policy_group?: string
  page?: number
  /** Sent as `per_page` query (Laravel-style). */
  per_page?: number
}

export interface PolicySubmitPayload {
  policy_name: string
  policy_group: string
  policy_description: string
}
